module.exports = __webpack_public_path__ + "img/logo.7dead8c9.png";